var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { get, isEmpty, map, find } from 'lodash';
import { convertTreeNodeIdToTreeNodeArray, convertTreeNodeIdArrayToTreeNodeArray, convertTreeNodeIdToTreeNode, convertOptionsIdArrayToOptionsArray } from './data-convert';
/**
 * 将object的value结构转换为string的结构
 */

var TreeNodeToTreeNodeIdHOC = function TreeNodeToTreeNodeIdHOC(WrappedComponent) {
  return function (_super) {
    __extends(WrapperComponent, _super);

    function WrapperComponent() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.displayName = 'TreeNodeToTreeNodeIdHOC';

      _this.onChange = function (value, name) {
        var onChange = _this.props.onChange;
        onChange(get(value, 'id', ''), name);
      };

      _this.transformValue = function (value) {
        var options = _this.props.options;

        if (isEmpty(options)) {
          return '';
        }

        return convertTreeNodeIdToTreeNode(value, options);
      };

      return _this;
    }

    WrapperComponent.prototype.render = function () {
      var value = this.props.value;
      var transformedValue = this.transformValue(value);

      var wrappedProps = __assign(__assign({}, this.props), {
        value: transformedValue,
        onChange: this.onChange
      });

      return React.createElement(WrappedComponent, __assign({}, wrappedProps));
    };

    return WrapperComponent;
  }(React.Component);
};
/**
 * 将objectArray的value结构转换为stringArray的结构
 */


var TreeNodeArrayToTreeNodeIdArrayHOC = function TreeNodeArrayToTreeNodeIdArrayHOC(WrappedComponent) {
  return function (_super) {
    __extends(WrapperComponent, _super);

    function WrapperComponent() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.displayName = 'TreeNodeArrayToTreeNodeIdArrayHOC';

      _this.onChange = function (value, name) {
        var onChange = _this.props.onChange;
        onChange(map(value, 'id'), name);
      };

      _this.transformValue = function (value) {
        var options = _this.props.options;

        if (isEmpty(options)) {
          return [];
        }

        return convertTreeNodeIdArrayToTreeNodeArray(value, options);
      };

      return _this;
    }

    WrapperComponent.prototype.render = function () {
      var value = this.props.value;
      var transformedValue = this.transformValue(value);

      var wrappedProps = __assign(__assign({}, this.props), {
        value: transformedValue,
        onChange: this.onChange
      });

      return React.createElement(WrappedComponent, __assign({}, wrappedProps));
    };

    return WrapperComponent;
  }(React.Component);
};
/**
 * 将objectArray的value结构转换为id的结构
 */


var TreeNodeArrayToTreeNodeIdHOC = function TreeNodeArrayToTreeNodeIdHOC(WrappedComponent) {
  return function (_super) {
    __extends(WrapperComponent, _super);

    function WrapperComponent() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.displayName = 'TreeNodeArrayToTreeNodeIdHOC';

      _this.onChange = function (value, name) {
        var onChange = _this.props.onChange;
        var transformedResult = get(value, "[" + (value.length - 1) + "].id", '');
        onChange(transformedResult, name);
      };

      _this.transformValue = function (value) {
        var options = _this.props.options;

        if (isEmpty(options)) {
          return [];
        }

        return convertTreeNodeIdToTreeNodeArray(value, options);
      };

      return _this;
    }

    WrapperComponent.prototype.render = function () {
      var value = this.props.value;
      var transformedValue = this.transformValue(value);

      var treeProps = __assign(__assign({}, this.props), {
        value: transformedValue,
        onChange: this.onChange
      });

      return React.createElement(WrappedComponent, __assign({}, treeProps));
    };

    return WrapperComponent;
  }(React.Component);
};
/**
 * 将objectArray的value结构转换为object的结构
 */


var TreeNodeArrayToTreeNodeObjectHOC = function TreeNodeArrayToTreeNodeObjectHOC(WrappedComponent) {
  return function (_super) {
    __extends(WrapperComponent, _super);

    function WrapperComponent() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.displayName = 'TreeNodeArrayToTreeNodeIdHOC';

      _this.onChange = function (value, name) {
        var onChange = _this.props.onChange;
        var transformedResult = value[value.length - 1];
        onChange(transformedResult, name);
      };

      _this.transformValue = function (value) {
        var options = _this.props.options;

        if (isEmpty(options)) {
          return [];
        }

        return convertTreeNodeIdToTreeNodeArray(value ? value.id : '', options);
      };

      return _this;
    }

    WrapperComponent.prototype.render = function () {
      var value = this.props.value;
      var transformedValue = this.transformValue(value);

      var treeProps = __assign(__assign({}, this.props), {
        value: transformedValue,
        onChange: this.onChange
      });

      return React.createElement(WrappedComponent, __assign({}, treeProps));
    };

    return WrapperComponent;
  }(React.Component);
};
/**
 * 将optionIdArray的value结构转换为optionArray的结构
 */


var OptionsIdArrayToOptionsArrayHOC = function OptionsIdArrayToOptionsArrayHOC(WrappedComponent) {
  return function (_super) {
    __extends(WrapperComponent, _super);

    function WrapperComponent() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.displayName = 'OptionsIdArrayToOptionsArrayHOC';

      _this.onChange = function (value, name) {
        var onChange = _this.props.onChange;
        var transformedResult = value.map(function (item) {
          return item.id;
        });
        onChange(transformedResult, name);
      };

      _this.transformValue = function (value) {
        var options = _this.props.options;

        if (isEmpty(options)) {
          return [];
        }

        return convertOptionsIdArrayToOptionsArray(value, options);
      };

      return _this;
    }

    WrapperComponent.prototype.render = function () {
      var value = this.props.value;
      var transformedValue = this.transformValue(value);

      var props = __assign(__assign({}, this.props), {
        value: transformedValue,
        onChange: this.onChange
      });

      return React.createElement(WrappedComponent, __assign({}, props));
    };

    return WrapperComponent;
  }(React.Component);
};

var OptionToIdHOC = function OptionToIdHOC(WrappedComponent) {
  return function (_super) {
    __extends(WrapperComponent, _super);

    function WrapperComponent() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.displayName = 'OptionToIdHOC';

      _this.onChange = function (value, name) {
        var _a = _this.props,
            onChange = _a.onChange,
            options = _a.options;
        onChange(find(options, {
          id: value
        }), name);
      };

      return _this;
    }

    WrapperComponent.prototype.render = function () {
      var _a;

      var value = this.props.value;

      var props = __assign(__assign({}, this.props), {
        value: (_a = value) === null || _a === void 0 ? void 0 : _a.id,
        onChange: this.onChange
      });

      return React.createElement(WrappedComponent, __assign({}, props));
    };

    return WrapperComponent;
  }(React.Component);
};

export { TreeNodeArrayToTreeNodeIdArrayHOC, TreeNodeToTreeNodeIdHOC, TreeNodeArrayToTreeNodeIdHOC, TreeNodeArrayToTreeNodeObjectHOC, OptionsIdArrayToOptionsArrayHOC, OptionToIdHOC };